import {isNotNil} from 'ramda';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && isNotNil(value);

// Strip the origin and query string so the route is just the path — no host, no query-string PII.
const toRoutePath = (url: string): string =>
  url.replace(/^https?:\/\/[^/]+/, '').replace(/\?.*$/, '');

/**
 * Extracts the failed request's route from an RTK Query rejected action's `meta`: the request path
 * when available (fetchBaseQuery sets `baseQueryMeta.request.url`), else the endpoint name.
 */
export const getApiErrorRoute = (meta: unknown): string | undefined => {
  if (!isRecord(meta)) {
    return undefined;
  }

  const baseQueryMeta = meta.baseQueryMeta;
  if (isRecord(baseQueryMeta)) {
    const request = baseQueryMeta.request;
    if (isRecord(request) && typeof request.url === 'string') {
      return toRoutePath(request.url);
    }
  }

  const arg = meta.arg;
  if (isRecord(arg) && typeof arg.endpointName === 'string') {
    return arg.endpointName;
  }

  return undefined;
};
